import React from "react";
import { RowColors, RowOptions } from "../TableSection/TableSection";
import { CardTable } from "../CardTable/CardTable";
import AssignmentsLogo from "../../assets/headings/assignments.svg"
import { SectionProps } from "../../App";
import { assignmentIcons } from "../../data/assignmentIcons";
import { getCourseContent } from "../../data/courseContent";
import { hideRowLinks, isCurrentProject, isPastDue, isReleased } from "../../data/releaseSchedule";

export class Assignments extends React.Component<SectionProps> {
  render() {
    const { assignmentsTable } = getCourseContent();
    const modifiedRows: RowOptions[] = assignmentsTable.rows.map((row) => {
      if (!isReleased(row)) {
        return {
          ...hideRowLinks(row),
          backgroundColor: RowColors.LOCKED,
          locked: true,
        };
      } else if (isPastDue(row)) {
        return {
          ...row,
          backgroundColor: RowColors.FINISHED,
        };
      } else {
        return {
          ...row,
          backgroundColor: RowColors.RELEASED,
          current: isCurrentProject(row, assignmentsTable.rows),
        };
      }
    });

    return (
      <section
        id="assignments"
        className={`anchor assignments ${this.props.static ? "static" : ""}`}
      >
        <div className="section-heading">
          <img
            className="assignments-logo logo"
            src={AssignmentsLogo}
            alt="assignments text"
          />
        </div>
        <CardTable
          header={assignmentsTable.header}
          rows={modifiedRows}
          resourceStartIndex={5}
          titleLinkLabel="Assignment handout"
          iconFor={(title) => assignmentIcons[title]}
          twoLine
          idFor={(title) =>
            title === "Fruit Ninja" ? "assignment-fruit-ninja" : undefined
          }
        />
      </section>
    );
  }
}
